module.exports = __webpack_public_path__ + "static/media/get-directions-map.eb155700.png";